
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'reconciliationcurrentworkorderIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'reconciliationcurrentworkorder',
				windowName: '采购单工单',
				windowType: 'modal',
				// formenabled:false,
				// autoLoad:true,
				// pagerConfig: {
				// 	enabled:false,
				// 	autoHidden: false,
				// 	border: true,
				// 	size: 'mini',
				// 	perfect: false,
				// 	currentPage: 1,
				// 	pageSize: 20,
				// 	pageSizes: [10, 20, 50, 100, 200, 500],
				// },
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
